<template>
  <div class="mt-40">
    <h3 class="is-size-6 mb-10 has-text-weight-bold has-text-default">Opportunité(s) en cours</h3>
    <v-client-table
      :data="opportunite"
      :columns="columns"
      :options="options"
      class="infoWindowMapTable">
      <div slot="data" slot-scope="props">
        {{props.row.data ? props.row.data.nomCommercial : ''}}
      </div>
    </v-client-table>
  </div>

</template>

<script>
import { TEXTS, RESULTS_PER_PAGE, PER_PAGE_VALUE } from '@/configuration/clientTableConf';
import moment from 'moment';
import { getOppByProduct } from '@/api/opportunite/index';

export default {
  name: 'liste-opportunites',
  props: {
    num: String,
  },
  data() {
    return {
      trad: {
        userId: 'Commercial',
        data: 'Client',
        themeCampagne: 'Thème de la campagne',
        dateCreation: 'Date de l’opportunité',
      },
      opportunite: [],
      limit: 5,
    };
  },
  computed: {
    columns() {
      return ['userId', 'data', 'themeCampagne', 'dateCreation'];
    },
    options() {
      return {
        headings: {
          userId: this.trad.userId,
          data: this.trad.data,
          themeCampagne: this.trad.themeCampagne,
          dateCreation: this.trad.dateCreation,
        },
        filterable: false,
        perPageValues: PER_PAGE_VALUE,
        perPage: RESULTS_PER_PAGE,
        texts: TEXTS,
        columnsClasses: {},
      };
    },
  },
  methods: {
    async actionGetOpp() {
      const loadingComponent = this.$buefy.loading.open({ container: null });
      try {
        this.opportunite = (await getOppByProduct('panneauxLc', this.num, this.limit)).data;
        this.opportunite.forEach(opp => {
          opp.dateCreation = moment(opp.dateCreation).format('DD/MM/YYYY');
        });
        loadingComponent.close();
      } catch (error) {
        loadingComponent.close();
      }
    },
  },
  async mounted() {
    await this.actionGetOpp();
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/creationOpportunite/venteFacesLc/recherche/cartographie/listeOpportunites.vue